import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import products from "../data/product";
import slugify from "../utils/slugify";

const ProductHighlights = () => {
    const selectedIds = [20, 24, 25, 41, 59, 65, 69, 98, 104, 128, 185, 202];

    const featuredProducts = products.filter(product =>
        selectedIds.includes(product.id)
    );

    return (
        <section className="section product-highlight-section">
            <Container>

                {/* Common Section Heading */}
                <div className="section-title fade-up">
                    <h2>Product Highlights</h2>
                    <p>
                        Trusted and field-proven agricultural solutions delivering
                        consistent performance across crops and regions.
                    </p>
                </div>

                <Row>
                    {featuredProducts.map((product) => (
                        <Col lg={3} md={4} sm={6} className="mb-4 fade-up" key={product.id}>
                            <div className="product-card">

                                <div className="product-image">
                                    <img src={product.image} alt={product.productName} />
                                </div>

                                <div className="product-content">
                                    <span className="product-category">
                                        {product.category}
                                    </span>
                                    <h4>{product.productName}</h4>
                                    <p>{product.technicalName}</p>
                                </div>

                                {/* Hover Overlay */}
                                <div className="product-overlay">
                                    <h4>{product.productName}</h4>
                                    <Link
                                        to={`/product/${slugify(product.productName)}`}
                                        className="product-btn"
                                    >
                                        View Details
                                    </Link>

                                </div>

                            </div>
                        </Col>
                    ))}
                </Row>

                {/* View All Button */}
                <div className="text-center mt-4 fade-up">
                    <Link to="/products" className="view-all-btn">
                        View All Products
                    </Link>
                </div>

            </Container>
        </section>
    );
};

export default ProductHighlights;
